import { redirect } from '@sveltejs/kit';
import type { LayoutLoad } from './$types';

const publicRoutes = ['/login'];

export const load: LayoutLoad = async ({ url }) => {
  if (typeof window === 'undefined') return {};

  const currentPath = url.pathname;

  if (publicRoutes.includes(currentPath)) {
    const savedUser = localStorage.getItem('neohris_user');
    const savedToken = localStorage.getItem('neohris_token');
    if (savedUser && savedToken) {
      throw redirect(302, '/dashboard');
    }
    return {};
  }

  const savedUser = localStorage.getItem('neohris_user');
  const savedToken = localStorage.getItem('neohris_token');

  if (!savedUser || !savedToken) {
    throw redirect(302, '/login');
  }

  return {};
};
